module.exports = __webpack_public_path__ + "img/The-W-Report-transparent-v2.fe987dfd.png";